import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Button from 'design-system/components/Button';

// Button used for verification metric filter buttons that appear on Metrics Cards
const StyledMetricsFilterButton = styled(Button)`
  margin: ${Spacing[2]};
  & svg {
    margin-right: ${Spacing[2]};
  }
`;

export default StyledMetricsFilterButton;
